// extracted by mini-css-extract-plugin
export default {"container":"JHqK46akJmx8m4K_ZeNo","selectedBankAccount":"SgSSLgGqXfbk4S__AT7g"};